import React, { useState } from 'react';
import axios from 'axios'
import PictureModal from '../../../../../components/Modals/PictureModal';
import system_translations from '../../../../../texts/system_translations';
import { onGetErrorMessage, onGetFileExtension, onGetImageURL2Blob } from '../../../../../shared/utility';
import { private_server } from '../../../../../config';

const ChangeImageModal = (props) => {

    const {id, open, onClose, onUpdateDataImage, language} = props
    const content = system_translations[language].modals.change_image_modal

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const onSubmit = async(file) => {
        if(!file){
            setError(content.error_msg)
            return
        }
        setError(null)
        try {
            setLoading(true)
            console.log(file)
            const _file = await onGetImageURL2Blob(file)
            const data = {name:'image', ext:onGetFileExtension(_file.name)}
            onUpdateDataImage(data, _file, file)
            onClose()
        } catch (error) {
            const _error = onGetErrorMessage(error)
            setError(_error ? _error.message : null)
        }
        setLoading(false)
    }

    /* const onDelete = async() => {
        try {
            setError(null)
            setLoading(true)
            await private_server.delete(`/product/${id}/image?name=image`)
            onCompleted()
            onClose()
        } catch (error) {
            const _error = onGetErrorMessage(error)
            setError(_error ? _error.message : null)
        }
        setLoading(false)
        
    } */

    return ( 
        <PictureModal open={open} onClose={onClose} loading={loading} error={error} language={language}
            title={content.title} btnLabel={content.button} onChangeFile={onSubmit} />
     );
}
 
export default ChangeImageModal;